import { FormHelperText, Grid, InputLabel } from '@material-ui/core';
import CropUploader from 'components/CropUploader';
import { Field } from 'formik';
import React, { Fragment } from 'react';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { IForm } from 'v2/components/Shared/Content';
import type IProfile from 'v2/interfaces/profile';

interface IProps extends IForm<IProfile> {}

const General = (props: IProps) => {
  const { setFocus, getError, values, setFieldValue, initialValues } = props;

  const setImage = (field: string, value: number) => {
    setFieldValue(field, value);
  };

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field label='Nome completo / Razão social' name='name' id='name' disabled onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Nome fantasia' name='business_name' id='business_name' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field
            label={values?.type === 'E' ? 'Documento' : 'CPF/CNPJ'}
            name='document_number'
            id='document_number'
            mask={values?.type === 'E' ? null : 'document'}
            disabled={Boolean(initialValues.document_number)}
            onFocus={setFocus}
            component={TextFormField}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            label='Inscrição municipal'
            name='municipal_registration'
            id='municipal_registration'
            onFocus={setFocus}
            disabled
            component={TextFormField}
          />
        </Grid>
        <Grid item xs={12}>
          <Field label='Inscrição estadual' name='state_registration' id='state_registration' disabled onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='E-mail' name='email' id='email' onFocus={setFocus} component={TextFormField} disabled />
        </Grid>
        <Grid item xs={12}>
          <Field label='Telefone' name='phone' id='phone' mask={'phone'} onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Celular' name='cellphone' id='cellphone' mask={'phone'} onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Site' name='website' id='website' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <InputLabel htmlFor='profile_photo' error={getError('profile_photo').error}>
            Imagem
          </InputLabel>
          <CropUploader
            id='profile_photo'
            name='profile_photo'
            fileName='profile_photo'
            uploadType='cnt_foto'
            onChange={setImage}
            image={values.profile_photo}
          />
          {getError('profile_photo') && <FormHelperText style={{ color: '#dc3f53' }}>{getError('profile_photo').helperText}</FormHelperText>}
        </Grid>
        <Grid item xs={12}>
          <Field label='Sobre' name='about' id='about' multiline rows={6} onFocus={setFocus} component={TextFormField} />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default General;
